module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "BM-Head-bmh"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_191",
      "title": "191"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-No-Indent-bmtx1"
  }, [_vm._v("I want to thank Grace Lavery and Christian Brown for answering an unending barrage of text messages asking for their opinions on every change, no matter how minor, I made to this manuscript, like two extremely tolerant optometry patients—“Is this one better? Or is "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("this")]), _vm._v(" one better?” There are no two people whose literary judgment I prize more, and this book has been immeasurably improved thanks to their thoughtful criticism.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-bmtx"
  }, [_vm._v("Thanks are also due to my editor, Libby Burton, whose careful attention to detail at every stage of the publishing process has been a great relief and a help to me. I am especially grateful to my longtime agent, Kate McKean, who has only ever praised my successes, corrected my errors, and made me money. I wish everyone in the world were like her.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b285ee4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0